import React from 'react'
import { Theme, withStyles } from '@material-ui/core/styles'
import Dialog from '@material-ui/core/Dialog'
import MuiDialogContent from '@material-ui/core/DialogContent'
import MuiDialogActions from '@material-ui/core/DialogActions'
import { Grid, makeStyles } from '@material-ui/core'
import { isMobile } from 'react-device-detect'
import close from '../assets/images/close.svg'

const DialogContent = withStyles((theme: Theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent)

const DialogActions = withStyles((theme: Theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions)

interface ChartTooltipModalProps {
  open?: any
  setOpen?: any
  handleClose?: any
}
const useStyles = makeStyles({
  content: {
    background: '#FFFFFF',
    boxSizing: 'border-box',
    borderRadius: 3,
    padding: '24 24',
  },
  title: {
    color: '#3393F3',
    fontSize: 14,
    fontWeight: 600,
    textTransform: 'uppercase',
  },
  subTitle: {
    color: '#3393F3',
    fontSize: 12,
    fontWeight: 400,
  },
  detailContent: {
    marginBottom: 12,
  },
  header: {
    marginBottom: 12,
    '& input': {
      float: 'right',
    },
  },
  typeHead: {
    fontSize: 14,
    color: 'rgba(24, 24, 24, 1)',
    fontWeight: 600,
  },
  typeDetail: {
    fontWeight: 400,
    fontSize: 14,
  },
})

const RiskEventTooltipModal = ({
  open,
  setOpen,
  handleClose,
}: ChartTooltipModalProps) => {
  const classes = useStyles()
  return (
    <div>
      <Dialog
        onClose={handleClose}
        aria-labelledby="customized-dialog-title"
        open={open}
      >
        <DialogContent>
          <div className={classes.content}>
            {!isMobile && (
              <div className={classes.header}>
                <span className={classes.title}>Risk Events </span>
                <span className={classes.subTitle}>
                  (Identification of Risk Patterns)
                </span>
                <input
                  type="image"
                  onClick={() => handleClose()}
                  src={close}
                  alt="closeBtn"
                />
              </div>
            )}

            {isMobile && (
              <>
                <div className={classes.header} style={{ marginBottom: 5 }}>
                  <span className={classes.title}>Risk Events </span>
                  <input
                    type="image"
                    onClick={() => handleClose()}
                    src={close}
                    alt="closeBtn"
                  />
                </div>
                <div className={classes.subTitle} style={{ marginBottom: 10 }}>
                  (Identification of Risk Patterns)
                </div>
              </>
            )}

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Risk Story: </span>
              <span className={classes.typeDetail}>
                Risk is usually a building storyline, very rarely made up of one
                sudden shock event, look at the risk story box as a string of
                events which build a risk story. This is not a news feed, it is
                a story to help you more easily identify these growing patterns.
                The value is fully in the storyline, go back 12 months or more
                and just read down the string of events, you will be surprised
                how quickly you can identify clear risk stories around the
                company. This has not been built as breaking news or to compete
                with your existing sources, it is fully focused on distilling a
                string of individual risk events into risk patterns so you can
                see the risk story
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>Risk Patterns: </span>
              <span className={classes.typeDetail}>
                Viewing the risk story over a long time frame, enables you to
                more easily identify high level patterns; I.E. negative events
                start to hit the companies cashflow, they quickly cut costs,
                raise cash, sell assets, start to move people. Companies (and
                boards) that have done bad things in the past usually don’t
                change their culture and will do bad things in the future
                (investigations, frauds, data breaches etc). All the individual
                risk events are feeding into and built around identifying these
                larger risk patterns.
              </span>
            </div>

            <div className={classes.detailContent}>
              <span className={classes.typeHead}>
                What’s in the Risk Story:{' '}
              </span>
              <span className={classes.typeDetail}>
                Machine reading every piece of information from highly curated
                sources that offer insight around the company, presented as a
                click through event to the underlying source. Specific focus on
                industry specific journals, as this is where a lot more open
                discussion on the company happens, financial media is secondary
                to this. Away from public information, proprietary events are
                also displayed from the wide analytical risk framework which is
                constantly analysing the company’s fundamentals, street
                perception and market reactions.
              </span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </div>
  )
}

export default React.memo(RiskEventTooltipModal)
